import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { DialogContent } from "@material-ui/core";
import Button from "@mui/material/Button";
import PaperPlaneAnimation from "../PaperPlaneAnimation";

const StyledInputElement = styled("input")`
  width: 100%;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3a415a;
  background: #f5f6fa;
  border: 1px solid #f5f6fa;
  border-radius: 5px;
  padding: 9px 15px;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #7a828a;
  }
`;

function SavingContent() {
  const [saved, setSaved] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const closeSaveDialog = () => {
    APP.arrangement.setDialog(undefined);
  };

  const save = () => {
    const fadeoutDialog = () => {
      $(".savedDialog").fadeOut(250);
      const resetDialog = () => APP.arrangement.setDialog(undefined);
      _.delay(resetDialog, 500);
    };
    APP.updateConfiguration();
    APP.save({
      callback: async () => {
        const URL = APP.wkfgBackendApi.getKonfigurationMail() + `&lang=${I18N.getLanguage()}`;
        try {
          await fetch(URL);
          setSaved(true);
          _.delay(fadeoutDialog, 2000);
        } catch (e) {
          console.error(e);
        }
      },
      quiet: true,
      preferUpdate: true,
      preferUpdate: APP.arrangement.state.booth.Inspiration ? false : true,
      // Hiermit kann ein create erzwungen werden
      // Wenn preferUpdate: false und forceNoUpdate wird ein create erzwungen
      forceNoUpdate: APP.arrangement.state.booth.Inspiration ? true : false,
      noFotoSnapshots: false,
      skipURLUpdate: true,
      modifyBeforeWrite: (configuration) => {
        configuration.Inspiration = false;
      },
    });
  };

  const validateEmail = (event) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value)) {
      APP.arrangement.state.userData.Email = {
        value: event.target.value,
        valid: true,
      };
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };

  useEffect(() => {
    validateEmail({
      target: {
        value: "",
      },
    });
  }, []);

  return (
    <>
      {!saved && (
        <div className={"savingDialog"}>
          <DialogTitle style={{ padding: "12px" }}>
            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton size="large" onClick={closeSaveDialog} color="black">
                <CancelIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent
            style={{
              minWidth: {
                xs: "100vw",
                md: "600px",
              },
            }}
          >
            <Box
              sx={{
                color: "#3A415A",
                fontSize: "1.4rem",
                marginBottom: "10px",
                textAlign: "center",
                width: "100%",
              }}
            >
              {I18N("SavingDialog:Save")}
            </Box>
            <Box
              sx={{
                color: "#3A415A",
                fontSize: "1.1rem",
                lineHeight: "32px",
                marginBottom: "18px",
                textAlign: "center",
              }}
            >
              {I18N("SavingDialog:Information")}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#F5F6FA",
                padding: "5px",
                margin: "0 auto 0 auto",
                maxWidth: "332px",
                borderRadius: "4px",
                border: "1px solid transparent",
                [emailError]: {
                  border: "1px solid #C91113",
                },
              }}
            >
              <StyledInputElement
                required={true}
                placeholder={I18N("SavingDialog:Email")}
                onChange={(e) => validateEmail(e)}
              />
              <Button onClick={save} disabled={emailError} variant={"contained"}>
                {I18N("SavingDialog:Send")}
              </Button>
            </Box>
            {emailError && (
              <Box sx={{ textAlign: "center", width: "100%", color: "#C91113", marginTop: "10px" }}>
                {I18N("Validation:Email")}
              </Box>
            )}
            <Box sx={{ height: "64px" }} />
          </DialogContent>
        </div>
      )}

      {saved && (
        <div className="savedDialog">
          <DialogTitle style={{ padding: "12px" }}>
            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton size="large" onClick={closeSaveDialog} color="black">
                <CancelIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent
            style={{
              minWidth: {
                xs: "100vw",
                md: "600px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: "#3A415A",
                fontSize: "1.4rem",
                width: "100%",
              }}
            >
              <Box sx={{ marginBottom: "50px" }}>{I18N("SavingDialog:Success")}</Box>
              <Box sx={{ marginBottom: "50px", textAlign: "center" }}>
                <PaperPlaneAnimation />
              </Box>
              <Box sx={{ marginBottom: "50px" }} />
            </Box>
          </DialogContent>
        </div>
      )}
    </>
  );
}

export default function SavingClosure(options) {
  return function Saving() {
    return <SavingContent />;
  };
}
